import { createContext } from "react";

const StakeContext = createContext();

export default StakeContext;
